import { ComponentPropsWithoutRef, ReactElement } from "react";

export const TableBody = (
  props: ComponentPropsWithoutRef<"tbody">,
): ReactElement => <tbody {...props} />;
